<template>
	<section class="home-news">
		<h3 class="section-heading container">Последние события округа</h3>
		<div class="container">
			<div class="row">
				
				<div class="col-12 col-sm-8 col-md-7 col-lg-5 col-xl-3" v-if="!loaded" v-for="cap in [1,2,3]" :key="cap">
					<div class="wrapper-post">
						<div class="post-photo"></div>
						<div class="post-info">
							<div class="heading">
								<div class="content-placeholder">
									<div class="container-loading p-lines-18">
										<div class="line"></div>
										<div class="line"></div>
										<div class="line"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<NewsItem v-for="event in events" :key="event.id" :event="event" col="col-12 col-sm-8 col-md-7 col-lg-5 col-xl-3"></NewsItem>
				
			</div>
			<div class="wrapper-btn-center">
				<router-link to="/events" class="btn">К событиям
					<div class="icon right-arrow"></div>
				</router-link>
			</div>
		</div>
		<div class="cutblock"></div>
	</section>
</template>

<script>
import store from "../../store/";
import NewsItem from "./../NewsItem";
export default {
	name: "HomeNews",
	store,
	components: {
		NewsItem
	},
	created() {
		this.$store.dispatch("HomeNews/fetchEvents");
	},
	computed: {
		loaded() {
			return this.$store.state["HomeNews"].loaded;
		},
		events() {
			return this.$store.state["HomeNews"].events;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/HomeNews/index.vue